import { Component, ChangeDetectionStrategy, signal, computed } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IrisTagI } from '@iris/common/models/IrisTag';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'iris-dms-grid-tag-name-template',
  imports: [
    MatTooltipModule,
  ],
  templateUrl: './dms-grid-tag-name-template.component.html',
  styleUrls: ['./dms-grid-tag-name-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridTagNameTemplateComponent implements ICellRendererAngularComp {
  private readonly data = signal<IrisTagI>(null);
  readonly tagName = computed(() => this.data()?.name);
  readonly tagColor = computed(() => this.data()?.color);

  agInit(params: ICellRendererParams<IrisTagI>): void {
    this.data.set(params.data);
  }

  refresh(): boolean {
    return true;
  }
}
